export const PEER_SPECIALISTS_QUERY = `Peerspecialists {  
    peerSpecialists{
      data {
        id
        attributes {
              label
              title
              peer_lists {
                description
                profile_image {
                    data {
                        attributes {
                            name
                            url
                        }
                    }
                }
                name
                program
                program_logo{
                  data {
                      attributes {
                          name
                          url
                      }
                  }
              }
              }
        }
      }
    }
  }`;
